import * as licenceApi from '../services/api/licence';

export const USER_LICENCES_RESET = 'USER_LICENCES_RESET';
export const USER_LICENCES_RECEIVED = 'USER_LICENCES_RECEIVED';

export function refreshUserLicences(userId) {

    return dispatch => {

        licenceApi
            .getUserLicences(userId)
            .then(res => {
                dispatch(userLicencesReceived(res.payload));
            });
    }
}

export function userLicencesReceived(licences) {
    return {
        type: USER_LICENCES_RECEIVED,
        licences
    }
}

export function resetUserLicences() {
    return {
        type: USER_LICENCES_RESET
    }
}